var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.152,
    height: 15.152,
    viewBox: "0 0 15.152 15.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041A\\u0443\\u043B\\u044C\\u0442\\u0443\\u0440\\u0430",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1677",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1677",
    d: "M396.426,268.344H398.2V272.6h-1.776Zm0,0",
    transform: "translate(-384.693 -260.403)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1678",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1678",
    d: "M282.809,268.344h1.776V272.6h-1.776Zm0,0",
    transform: "translate(-274.438 -260.403)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1679",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1679",
    d: "M169.191,268.344h1.776V272.6h-1.776Zm0,0",
    transform: "translate(-164.183 -260.403)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1680",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1680",
    d: "M55.578,268.344h1.776V272.6H55.578Zm0,0",
    transform: "translate(-53.932 -260.403)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1681",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1681",
    d: "M48.625,208.788v-.444H35.578v.444a.444.444,0,0,0,.444.444H48.181A.444.444,0,0,0,48.625,208.788Zm0,0",
    transform: "translate(-34.524 -202.178)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1682",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1682",
    d: "M14.723,442H.459a.444.444,0,0,0-.444.444v1.184a.444.444,0,0,0,.444.444H14.723a.444.444,0,0,0,.444-.444v-1.184A.444.444,0,0,0,14.723,442Zm0,0",
    transform: "translate(-0.013 -428.919)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1683",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1683",
    d: "M.445,5.278H14.71a.444.444,0,0,0,.233-.822L7.81.066a.444.444,0,0,0-.465,0L.212,4.456a.444.444,0,0,0,.233.822ZM7.276,2.611h.6a.444.444,0,1,1,0,.888h-.6a.444.444,0,0,1,0-.888Zm0,0",
    transform: "translate(0)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/Culture.9d0483d0251131bc678daf087a92c35c.svg";
export { ForwardRef as ReactComponent };